// redux/store.ts: sets up the store and configures redux-persist.
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist"; //persistReducer and persistStore for state persistence.
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { combineReducers } from "redux";

import authReducer from "../features/auth/store/authSlice";
import userReducer from "../features/auth/store/userSlice";
import dataPlanSlice from "../features/auth/store/dataPlanSlice";
import electricPlanSlice from "../features/auth/store/electricPlanSlice";
import cablePlanSlice from "../features/auth/store/cablePlanSlice";
import airtimePlanSlice from "../features/auth/store/airtimePlanSlice";
import dataProviderSlice from "../features/auth/store/dataProviderSlice";
import dataCategorySlice from "../features/auth/store/dataCategorySlice";
import electricCategorySlice from "../features/auth/store/electricCategorySlice";
import electricProviderSlice from "../features/auth/store/electricProviderSlice";
import cableProviderSlice from "../features/auth/store/cableProviderSlice";
import cableCategorySlice from "../features/auth/store/cableCategorySlice";
import airtimeProviderSlice from "../features/auth/store/airtimeProviderSlice";
import airtimeCategorySlice from "../features/auth/store/airtimeCategorySlice";
import gamecardProviderSlice from "../features/auth/store/gamecardProviderSlice";
import gamecardCategorySlice from "../features/auth/store/gamecardCategorySlice";
import gamecardPlanSlice from "../features/auth/store/gamecardPlanSlice";
import giftcardProviderSlice from "../features/auth/store/giftcardProviderSlice";
import giftcardCategorySlice from "../features/auth/store/giftcardCategorySlice";
import giftcardPlanSlice from "../features/auth/store/giftcardPlanSlice";
import dgcoinProviderSlice from "../features/auth/store/dgcoinProviderSlice";
import dgcoinCategorySlice from "../features/auth/store/dgcoinCategorySlice";
import dgcoinPlanSlice from "../features/auth/store/dgcoinPlanSlice";
import topupcardProviderSlice from "../features/auth/store/topupcardProviderSlice";
import topupcardCategorySlice from "../features/auth/store/topupcardCategorySlice";
import topupcardPlanSlice from "../features/auth/store/topupcardPlanSlice";
import sliderSlice from "../features/auth/store/sliderSlice";
import currencySlice from "../features/auth/store/currencySlice";
import countrySlice from "../features/auth/store/countrySlice";
import dashboardStatSlice from "../features/auth/store/dashboardStatSlice";
import transactionSlice from "../features/auth/store/transactionSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  dataProviders: dataProviderSlice,
  dataCategories: dataCategorySlice,
  dataPlans: dataPlanSlice,
  electricPlans: electricPlanSlice,
  electricCategories: electricCategorySlice,
  electricProviders: electricProviderSlice,
  airtimePlans: airtimePlanSlice,
  airtimeProviders: airtimeProviderSlice,
  airtimeCategories: airtimeCategorySlice,
  cablePlans: cablePlanSlice,
  cableProviders: cableProviderSlice,
  cableCategories: cableCategorySlice,
  gamecardProviders: gamecardProviderSlice,
  gamecardCategories: gamecardCategorySlice,
  gamecardPlans: gamecardPlanSlice,
  giftcardProviders: giftcardProviderSlice,
  giftcardCategories: giftcardCategorySlice,
  giftcardPlans: giftcardPlanSlice,
  dgcoinProviders: dgcoinProviderSlice,
  dgcoinCategories: dgcoinCategorySlice,
  dgcoinPlans: dgcoinPlanSlice,
  topupcardProviders: topupcardProviderSlice,
  topupcardCategories: topupcardCategorySlice,
  topupcardPlans: topupcardPlanSlice,
  sliders: sliderSlice,
  currencies: currencySlice,
  countries: countrySlice,
  dashboardStats: dashboardStatSlice,
  transactions: transactionSlice,
});

const persistConfig = {
  key: "root", // Key for the persisted state.
  storage, // Storage engine (localStorage for web).
  whitelist: ["auth"], // Only persist the auth slice
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const persistor = persistStore(store); //It ensures that the parts of the store wrapped with the persistReducer (in this case, persistedReducer) are persisted to the specified storage (e.g., localStorage).

// get back to these
export type RootState = ReturnType<typeof store.getState>; //RootState is the type for your entire store's state.
export type AppDispatch = typeof store.dispatch; //AppDispatch is the type for your store's dispatch function, ensuring type-safe action dispatching.
